import React from "react";
import styles from "./Icons.module.scss"
import Check from './SVG/Check'
import Incorrect from './SVG/Incorrect'

const Icon = (props) => {

    const { name } = props

    const setIcon = (name) => {

        switch(name){
            case 'check' : return <Check className={styles.iconSvg}/> 
            case 'incorrect' : return <Incorrect className={styles.iconSvg} /> 
            default: return <></>
        }
    }

    return setIcon(name)

}

export  {
    Check,
    Incorrect
}
export default Icon